import Vue from 'vue'
import VueEasytable from "vue-easytable";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue';
import router from './router';
Vue.use(VueEasytable);
Vue.use(ElementUI);
Vue.config.productionTip = false;

new Vue({
  el:'#app',
  router,
  render: h => h(App)
})
